import { t } from "i18next"

export const InquiryType = [
  { label: t("All"), value: "" },
  { label: t("customerRelated"), value: "customer-related" },
  { label: t("others"), value: "others" },
]
